const header_search_toggle = document.querySelector('.site-header .open-search');
const header_close_search = document.querySelector('.site-header .close-search');
const header_result_pages = document.querySelector('.header-search-results__pages');
const header_search_wrap = document.querySelector('.header-search-wrap');
const header_search_field = document.querySelector('#header-search-field');
const site_header_search = document.querySelector('.site-header');
let keyup_timer;

const header_search = {

    init: function() {
        
        header_search_field.addEventListener('keyup', function() {
            if ( header_search_field.value.length >= 3 ) {
                clearTimeout(keyup_timer);

                keyup_timer = setTimeout( function() {
                    header_search.getPages(header_search_field.value);
                }, 100);
                
            }
        });
    },

    getPages: function(query) {

        let articles = '';
    
        $.ajax({
          url: '/search',
          data: {
            type: 'page,article,product',
            view: 'json',
            q: query,
          },
          dataType: "json",
          success: function(data){

            if ( data.results ) {
                    data.results.map( function(result) {
                        let content = header_search.stripHtml(result.content);
                        content = content.replace(/(<([^>]+)>)/gi, "");
                        
                        content = header_search.textTruncate(content,200);
                        articles += `
                         <a href="${result.url}">
                        <div class="featured_image">
                        <img src="${result.article_image}" alt=""/>
                        <img src="${result.featured_image}" alt=""/>
                        </div>
                        <h4>${result.title}</h3>
                        ${content}
                        <div class="more-wrap">Read More <div class="more"></div></div>
                        </a>
                        `;
                    
                    });
                }

                if ( !articles ) {
                  articles = `<h2 style="grid-column: span 4;
                  text-align: center;
                  justify-self: center;
                  display: block;
                  width: 100%;">Nothing found</h2>`;
                }

                header_result_pages.innerHTML = articles;
                
          }
        });

        
    },

    stripHtml: function(html){
      // Create a new div element
      var temporalDivElement = document.createElement("div");
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html;
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || "";
    },

    textTruncate: function(str, length, ending) {
        if (length == null) {
          length = 100;
        }
        if (ending == null) {
          ending = '...';
        }
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending;
        } else {
          return str;
        }
    },

    openSearch: function() {
      document.querySelector('html').style.overflow = 'hidden';
        header_search_wrap.classList.add('open');
        header_search_field.focus();
        site_header_search.classList.add('header--megamenu-visible', 'header--megamenu-visible-search');
    },

    closeSearch: function() {
        header_search_wrap.classList.remove('open');
        site_header_search.classList.remove('header--megamenu-visible', 'header--megamenu-visible-search');
        document.querySelector('html').style.overflow = 'visible';
    }

};

header_search.init();


document.addEventListener('click', function() {
    header_search.closeSearch()
});

header_search_wrap.addEventListener('click', function(e) {
    e.stopPropagation()
});

header_close_search.addEventListener('click', function(e) {
  e.stopPropagation();
  header_search.closeSearch()
});

header_search_toggle.addEventListener('click', function(e) {
  e.stopPropagation();

  if ( header_search_wrap.classList.contains('open') ) {
    header_search.closeSearch();
  } else {
    header_search.openSearch();
  }
  
});